import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20250424-helferstunden",
        datum: "24.04.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Helferstunden-Typen deaktivieren",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "Helferstunden-Typen können jetzt deaktiviert werden."
            + " In der Liste der Helferstunden-Typen (System → Einstellungen → Mitglieder – Helferstunden) kannst du jetzt per Checkbox markieren, welche Typen aktiv sind."
            + " Nur diese erscheinen dann bei der Erfassung neuer Stunden – auch in der Mobile-App!"
            + " Inaktive Typen bleiben für Auswertungen in der Statistik bestehen.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/?p=11116",
            },
        ],
    },
    {
        id: "20250424-verbesserungen",
        datum: "24.04.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Allgemeine Verbesserungen",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "<ul>"
            + "<li>⚙️ In den Einstellungen zu Rechnungen → Identifikationsnummern lässt sich nun auch die Registernummer hinterlegen.</li>"
            + "<li>📤️ Beim Export von Veranstaltungslisten wird nun auch die zugewiesene Kategorie mit ausgegeben.</li>"
            + "</ul>",
        ],
        aktions: [],
    },
];

export {
    insights,
};
